import DEFAULT_SESSION from '@discover-data/stores/restaurant/model/session/default';
import isValidSession from '@discover-data/stores/hooks/session/isValid';
import sessionTypes, { sessionLabels } from '@discover-data/stores/restaurant/model/session/types';
import useSession from '@discover-data/stores/hooks/session/useSession';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@discover-ui/select';
import { SelectTriggerProps } from '@discover-ui/select/trigger';
import { useAnalytics } from '@/components/analytics/hooks/useAnalytics';

export type SessionSelectProps = Omit<
  React.ComponentPropsWithoutRef<'select'>,
  'value' | 'onValueChange' | 'dir' | 'defaultValue'
> & {
  defaultValue?: string;
  triggerProps?: SelectTriggerProps;
};

export default function SessionSelect({
  className,
  children,
  defaultValue,
  triggerProps,
  ...props
}: SessionSelectProps) {
  const [session, setSession] = useSession();
  const { track } = useAnalytics();

  return (
    <Select
      value={session}
      onValueChange={async (newSession) => {
        if (isValidSession(newSession)) {
          track('button_clicked', {
            button_name: 'session picker',
            button_type: 'selection',
            button_copy: newSession,
            button_value: newSession,
          });
          setSession(newSession);
        }
      }}
      defaultValue={
        defaultValue ? defaultValue?.[0].toUpperCase() + defaultValue?.slice(1) : DEFAULT_SESSION
      }
      {...props}>
      <SelectTrigger className={className} {...triggerProps}>
        {children}
        <SelectValue placeholder="Pick a session">{sessionLabels[session]}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {Object.values(sessionTypes)
          .filter((option) => option !== sessionTypes.Dinner2)
          .map((option) => (
            <SelectItem key={option} value={option}>
              {sessionLabels[option]}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
}
